import React from 'react';
import DropDownList from '../../Utils/DropDownList/DropDownList';
import { IDropDownListItem } from '../../../Types/DropDownList/IDropDownListItem';
import styles from './PermissionsItem.module.css';

type PermissionsItemProps = {
  title: string;
  description: string;
  options: IDropDownListItem[];
  value: string | number;
  onChange?: (selectedItem: IDropDownListItem) => void;
  readonly?: boolean;
  /** Shown as pills next to the title (e.g. Owner, Lead). */
  badges?: string[];
};

const PermissionsItem = ({
  title,
  description,
  options,
  value,
  onChange,
  readonly,
  badges,
}: PermissionsItemProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.columnLeft}>
        <div className={styles.titleRow}>
          <div className={styles.title}>{title}</div>
          {badges && badges.length > 0 ? (
            <div className={styles.badges} role="group" aria-label="User roles">
              {badges.map((label) => {
                const key = label.toLowerCase();
                const pillClass =
                  key === 'owner' || key === 'lead'
                    ? `${styles.badge} ${styles.badgeAccent}`
                    : styles.badge;
                return (
                  <span key={`${title}-${label}`} className={pillClass}>
                    {label}
                  </span>
                );
              })}
            </div>
          ) : null}
        </div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.columnRight}>
        <DropDownList
          value={value}
          placeholder="Select..."
          data={options}
          onChange={onChange}
          readonly={readonly}
        />
      </div>
    </div>
  );
};

export default PermissionsItem;
